import { render, staticRenderFns } from "./GuidesLayout.vue?vue&type=template&id=036d1e52&"
import script from "./GuidesLayout.vue?vue&type=script&lang=js&"
export * from "./GuidesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036d1e52')) {
      api.createRecord('036d1e52', component.options)
    } else {
      api.reload('036d1e52', component.options)
    }
    module.hot.accept("./GuidesLayout.vue?vue&type=template&id=036d1e52&", function () {
      api.rerender('036d1e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/GuidesLayout.vue"
export default component.exports